module.exports = __webpack_public_path__ + "img/part5.8c3ea077.png";